module.exports = function(menus) {
	'use strict'
	menus.directive('menusDir',menusDir);
	menusDir.$inject=[];
	function menusDir() {
		return {
			template: require('./partial/menus.html'),
			controller:'menusController',
			controllerAs:'vmm',
			link: function(scope, element, attrs, ctrl) {
				    
			}

		}
	}
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/menusModule/menus/js/directive/menusDirective.js
// module id = 528
// module chunks = 0